import React from "react";
import { useState } from "react";
import TablaGestion from "../../components/shared/layout/Table";
import { RegistroMision } from "../../structure/Tables";
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import LocalPrintshopTwoToneIcon from '@mui/icons-material/LocalPrintshopTwoTone';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import {Button, MenuItem} from "@mui/material";
import Grid from "@mui/material/Grid";
import {DatePickerCustomed} from "../../components/shared/Litles/dates";
import TextField from "@mui/material/TextField";
import {PersonaButtonforForms} from "../../components/shared/Litles/PersonaButton";
import Box from "@mui/material/Box";
import Loader2 from "../../components/shared/layout/Loader2";
import {ModalsubCreator} from "../../components/shared/layout/ModalsubSelector";
import Modal from "@mui/material/Modal";
import SelectDetalleCatalogoModal from "../../components/shared/Litles/SelectDetalleCatalogoModal";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import IconButton from "@mui/material/IconButton";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 250,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};


export default function RegistroMisionView(props){
    const {data, addRow, handleEditar, guardarRegistro, setCatchResponse, setDataResponse, actionPrint, rules, opciones, listCiudades, listEstados, listPaises}=props;
    const [page, setPage]=useState(0)
    const [opensub, setOpensub]=useState(false)
    const [openCasa, setOpenCasa] = useState(false)
    const [openMision, setOpenMision] = useState(false)
    const [loader, setLoader2]=useState(false)

    const [sortModel, setSortModel] = React.useState([
        {
          field: 'fecha',
          sort: 'asc',
        },
      ]);

    const addRowCore = () => {
        setOpensub(true);
    }

    const handleClosesub = async (row)=>{
        if (row) {
            await addRow(row);
        }
        setOpensub(false);
    }

    const handleCloseCasa = (nombre, id) => {
        setOpenCasa(false);
    }
    const handleOpenCasa = () => {
        setOpenCasa(true);
    }

    const handleCloseMision = (nombre, id) => {
        setOpenMision(false);
    }
    const handleOpenMision = () => {
        setOpenMision(true);
    }

    const printButton=actionPrint? <Button
            key={"printRM"}
            id={"boton1"}
            onClick={actionPrint}
            sx={{
                "&:hover":{
                    //background:"#d0d0d0",
                    //borderBottom: "1px solid #d0d0d0"
                },
                width:5,
                padding:0,
            }}
        >
        <LocalPrintshopTwoToneIcon titleAccess="Imprimir Reporte"></LocalPrintshopTwoToneIcon>
    </Button> :null
    

    const botonesAccion = [
        {
        field: "action",
        headerName: <div  style={{marginBottom:"-10px"}}><AddTwoToneIcon titleAccess="Agregar" onClick={(e)=>addRowCore()}/></div>,
        width: 50,
        sortable: false,
        
        //width: 400,
        
        renderCell: (params) => {
            return (
            <div className="cellAction" style={{ display:"flex"}}>
                <div className="viewButton" style={{color:"#d7a200", border:"none"}} onClick={(e)=>{
                if(!params.row.edit){guardarRegistro(params.row)}; params.row.edit= !params.row.edit
                }} >{params.row.edit?<EditTwoToneIcon titleAccess="Editar" />: <SaveTwoToneIcon titleAccess="Guardar"/> }
                </div>
            </div>
            );
        },
        },
    ];

    const fieldProps = (datos, changeHandler) => [
        (<Grid item xs={12} md={4} lg={4}>
            <DatePickerCustomed
                name={"fecha"}
                value={datos["fecha"] || ''}
                label={"Fecha"}
                onChange={(e) => changeHandler({target: {name: "fecha", value: e["$d"]}})}
            >
            </DatePickerCustomed>
        </Grid>),
        (<Grid xs={12} md={8} lg={8} container >
            <Grid container item xs={12} md={2} lg={2}>
                <SelectDetalleCatalogoModal parent={15} open={openCasa} handleClose={(nombre, id) => {
                    const e = {};
                    e.target = {
                        name: 'ct_casa_id',
                        value: id,
                    }
                    changeHandler(e);
                    handleCloseCasa(nombre, id);
                }}></SelectDetalleCatalogoModal>
                <IconButton aria-label="delete" size="large" onClick={handleOpenCasa}>
                    <ContentPasteSearchIcon value={"field.name"} fontSize="inherit" />
                </IconButton>
            </Grid>
            <Grid item xs={12} md={10} lg={10}>
                <TextField
                    fullWidth
                    select
                    margin="normal"
                    name={"ct_casa_id"}
                    value={datos['ct_casa_id'] || 0}
                    label={"Casa"}
                    onChange={(e) => changeHandler(e)}
                >
                    {opciones.detallecatalogo.filter(x => x.catalogo_id === 15).map((x, i) => (
                        <MenuItem key={i} value={x.id}>
                            {x.descripcion}
                        </MenuItem>
                    ))

                    }
                </TextField>
            </Grid>
        </Grid>),
        (<Grid item xs={12} md={4} lg={4}>
            <TextField
                fullWidth
                select
                name={"pais_id"}
                value={datos['pais_id'] || 0}
                label={"Pais"}
                onChange={(e) => changeHandler(e)}
            >
                {listPaises.map((x, i) => (
                    <MenuItem key={i} value={x.id}>
                        {x.nombre}
                    </MenuItem>
                ))
                }
            </TextField>
        </Grid>),
        (<Grid item xs={12} md={4} lg={4}>
            <TextField
                fullWidth
                select
                disabled={(datos["pais_id"] || 0) === 0}
                name={"estado_id"}
                value={datos['estado_id'] || 0}
                label={"Estado"}
                onChange={(e) => changeHandler(e)}
            >
                {listEstados.filter(x => x.pais_id === (datos["pais_id"] || 0)).map((x, i) => (
                    <MenuItem key={i} value={x.id}>
                        {x.nombre}
                    </MenuItem>
                ))
                }
            </TextField>
        </Grid>),
        (<Grid item xs={12} md={4} lg={4}>
            <TextField
                fullWidth
                select
                disabled={(datos["estado_id"] || 0) === 0}
                name={"ciudad_id"}
                value={datos['ciudad_id'] || 0}
                label={"Ciudad"}
                onChange={(e) => changeHandler(e)}
            >
                {listCiudades.filter(x => x.estado_id === (datos["estado_id"] || 0)).map((x, i) => (
                    <MenuItem key={i} value={x.id}>
                        {x.nombre}
                    </MenuItem>
                ))
                }
            </TextField>
        </Grid>),
        (<Grid item xs={12} md={6} lg={6} display={"flex"}>
            <PersonaButtonforForms setDataResponse={setDataResponse} setCatchResponse={setCatchResponse}
                                   value={datos['superiora_id']} value_name={'superiora_id'}
                                   Label={datos['superiora']} title={'Superiora'} label_name={'superiora'}
                                   handleChange={(id, name, nombrecompleto, label_name) => {
                                       const e = [
                                           {
                                               name: name,
                                               value: id,
                                           },
                                           {
                                               name: label_name,
                                               value: nombrecompleto,
                                           }
                                       ];
                                       changeHandler(e);
                                   }}/>
        </Grid>),
        (<Grid xs={12} md={6} lg={6} container>
            <Grid container item xs={12} md={2} lg={2}>
                <SelectDetalleCatalogoModal parent={16} open={openMision} handleClose={(nombre, id) => {
                    const e = {};
                    e.target = {
                        name: 'ct_mision_id',
                        value: id,
                    }
                    changeHandler(e);
                    handleCloseMision(nombre, id);
                }}></SelectDetalleCatalogoModal>
                <IconButton aria-label="delete" size="large" onClick={handleOpenMision}>
                    <ContentPasteSearchIcon value={"field.name"} fontSize="inherit" />
                </IconButton>
            </Grid>
            <Grid item xs={12} md={10} lg={10}>
                <TextField
                    fullWidth
                    select
                    margin="normal"
                    name={"ct_mision_id"}
                    value={datos['ct_mision_id'] || 0}
                    label={"Mision que desarrolla"}
                    onChange={(e) => changeHandler(e)}
                >
                    {opciones.detallecatalogo.filter(x => x.catalogo_id === 16).map((x, i) => (
                        <MenuItem key={i} value={x.id}>
                            {x.descripcion}
                        </MenuItem>
                    ))

                    }
                </TextField>
            </Grid>
        </Grid>)
    ];

    return(
        <React.Fragment>
            <Modal
                hideBackdrop
                open={opensub}
                onClose={handleClosesub}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={{ ...style, width: 580 }}>
                    <Loader2 onLoader={loader}/>
                    <h2 id="parent-modal-title">Nuevo</h2>
                    <ModalsubCreator
                        getFields={fieldProps}
                        handleClose={handleClosesub}
                        datatable={data}
                    />
                </Box>
            </Modal>

            <TablaGestion 
                botones ={botonesAccion}
                data={data}
                aditionalButton={printButton}
                sortModel={sortModel}
                setSortModel={setSortModel}
                formato = {RegistroMision}
                titulo={"Registro de misiones realizadas."}
                paginationModel={page}
                setPaginationModel={setPage}
            />
        </React.Fragment>
    )
}
